import AttributeModal from './AttributeModal'

export default AttributeModal
